"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WRAP_OPTIONS = exports.JUSTIFY_OPTIONS = exports.DIRECTION_OPTIONS = exports.ALIGN_SELF_OPTIONS = exports.ALIGN_OPTIONS = void 0;
var ALIGN_OPTIONS = {
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
exports.ALIGN_OPTIONS = ALIGN_OPTIONS;
var ALIGN_SELF_OPTIONS = {
  auto: '',
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
exports.ALIGN_SELF_OPTIONS = ALIGN_SELF_OPTIONS;
var DIRECTION_OPTIONS = {
  column: 'column',
  row: '',
  'column-reverse': 'column-reverse',
  'row-reverse': 'row-reverse'
};
exports.DIRECTION_OPTIONS = DIRECTION_OPTIONS;
var JUSTIFY_OPTIONS = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start'
};
exports.JUSTIFY_OPTIONS = JUSTIFY_OPTIONS;
var WRAP_OPTIONS = {
  nowrap: '',
  wrap: 'wrap'
};
exports.WRAP_OPTIONS = WRAP_OPTIONS;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/layout/FlexConstants.js
// module id = 577
// module chunks = 5 6